import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const invokews = async (urlCmd, bodyParams) => {

    let url = `/api/jsonws/invoke`;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                [urlCmd]: bodyParams,
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}